import Constants from '../constants/constants';
import { httpGet, httpPost } from './api/axios_api';
import actions from './functional_skills_actions';

export async function getFunctionalSkills() {
  const url = `${Constants.BACKEND_URL}/get-functional-skills/`;
  return httpGet(url, {});
}

export async function startNewFunctionalSkillSession(functionalSkillID, playerId) {
  const url = `${Constants.BACKEND_URL}/start-new-functional-skill-session/`;
  const params = {
    functional_skill_id: functionalSkillID,
  };

  if (typeof playerId !== 'undefined' && playerId !== -1) {
    params.player_id = playerId;
  }

  const config = {
    params: params,
  };

  return httpPost(url, config);
}

export function newFunctionalSkillSession(functionalSkillID) {
  return (dispatch) => {
    const url = `${Constants.BACKEND_URL}/start-new-functional-skill-session/`;
    const params = {
      functional_skill_id: functionalSkillID,
    };
    const config = {
      params: params,
    };
    httpPost(url, config).then((response) => {
      if (response.data.success) {
        dispatch({
          type: actions.startedNewSkillSession,
          data: { [functionalSkillID]: response.data.new_functional_skill_session_id },
        });
      }
    });
  };
}

const INITIAL_STATE = {
  functionalSkills: [],
  functionalSkillSessionIds: {},
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.gotFunctionalSkills:
      return {
        ...state,
        functionalSkills: [...action.data],
      };
    case actions.startedNewSkillSession:
      return {
        ...state,
        functionalSkillSessionIds: { ...state.functionalSkillSessionIds, ...action.data },
      };
    default:
      return { ...state };
  }
}
